import React from "react";
import suitedBoy from "../../assets/img/steps/candidate/suited-boy.png";
import suitedGirl from "../../assets/img/steps/candidate/suited-girl.png";
import {Button} from "reactstrap";

const Greetings = ({eventData, switchComponent, isEventActive}) => {


    return (
        <div className="d-flex justify-content-between">
            <div className="d-none d-lg-block">
                {/*<img src={left} alt=""/>*/}
                <img src={suitedBoy} alt=""/>
            </div>
            {/*<Container className="m-auto">*/}
            <div className="text-center px-lg-5 mt-lg-5 pt-lg-5">
                <h3 className="main-heading">Greetings!</h3>
                <p className="details-p">
                    Welcome to our Game Assessment! Get ready to embark on an exciting journey, where your skills and
                    wit will be put to the test. Before you dive in, we kindly request some essential information from
                    you. Once you provide the details, we will share the assessment game with you.
                </p>
                <p className="details-p">
                    All the information gathered will be use for game play & will not be used for any distribution.
                    Check our <a href="https://activ8games.com/privacy.html" target="_blank">Privacy Policy.</a>
                </p>
                {isEventActive ? (
                    <Button
                        className="beginBtn startButton"
                        color=""
                        onClick={() => switchComponent("basicInfo")}
                    >
                        <span className="text-white font-weight-normal">Lets begin!</span>
                    </Button>
                ) : <p className="details-p">Registration closed. Please contact HR for any further assistance.</p>}
            </div>
            {/*</Container>*/}
            <div className="d-none d-lg-block">
                {/*<img src={right} alt="" />*/}
                <img src={suitedGirl} alt=""/>
            </div>
        </div>
    );
};

export default Greetings;
